import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Button from '@ids/button';

const TaxSeasonPromo = (props) => {
  const [message, setMessage] = useState('');
  const [messageLite, setMessageLIte] = useState('');
  const [showOrderNow, setShowOrderNow] = useState(false);

  const getDeadline = () => {
    const currentMonth = new Date().getMonth();
    const currentYear = new Date().getFullYear();
    let deadlineYear = currentYear;
    /* istanbul ignore next line */
    if (currentMonth !== 0) {
      deadlineYear = currentYear + 1;
    }
    return new Date(deadlineYear, 0, 31).toLocaleDateString('en-US');
  };

  useEffect(() => {
    switch (props.page) {
      case 'HOME':
      case 'INPRODUCTLANDING':
        setMessage(`Don't miss the ${getDeadline()} deadline.`);
        setMessageLIte('Buy your W-2 and 1099 tax kits today.');
        setShowOrderNow(true);
        break;
      case 'ALL_CHECKS':
      case 'ALL_TAX':
      default:
        setMessage(`Don't miss the ${getDeadline()} deadline.`);
        setMessageLIte('Order your W-2 and 1099 tax kits now.');
        setShowOrderNow(false);
        break;
    }
  }, [props.page]);

  return (
    <div className="tax-season-banner-container">
      <Link
        to="/tax-forms"
        data-wa-link="Tax Banner : All checks page"
        data-ui-object="link"
        data-refer-ui-access-point="all_checks_page | tax_season_banner_promo"
      >
        <div className="tax-season-banner-rectangle">
          <div className="tax-banner-txt">{message}</div>
          <div className="tax-banner-txt-lite">{messageLite}</div>
          {showOrderNow && (
            <Button
              buttonType="primary"
              theme="quickbooks"
              className="banner-order-now-btn"
              data-ui-object="button"
              data-refer-ui-access-point="all_checks_page | order_now"
            >
              Order now
            </Button>
          )}
        </div>
      </Link>
    </div>
  );
};

TaxSeasonPromo.propTypes = {
  page: PropTypes.string,
};

export default TaxSeasonPromo;
